<p-dialog *ngIf="displayRevenueBalanceDialog && (RevenueBalanceType.Project == revenueBalanceType || RevenueBalanceType.FirmFixedClin == revenueBalanceType)"
          (onHide)="hideDialog($event)" [(visible)]="displayRevenueBalanceDialog"  [style]="DialogStyle65"
          header="Initial Revenue" styleClass="revenue-dialog" [responsive]="true" [closable]="false">

  <form #dialogForm="ngForm">

    <div class="p-grid">
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label *ngIf="projectId"> Project Name</label>
          <label *ngIf="clinId"> Clin Name</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{clinOrProjectName}}
        </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label> Year</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{selectedRevenue?.currentYear}}
        </div>
        </div>
      </div>

      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label> Accounting Period*</label>
        </div>
          <div class="p-col-12 p-md-8 p-lg-8">
        {{orgAccountingCalendarBeforeGoLive?.title}} - {{orgAccountingCalendarBeforeGoLive?.start | date: Format.Date}} - {{orgAccountingCalendarBeforeGoLive?.end | date: Format.Date}}
          </div>
          </div>
      </div>
    </div>

    <div>
      <strong> Revenue: </strong>
      <p-table [value]="taskBalanceTable">
        <ng-template pTemplate="header">
          <tr>
            <th>Field</th>
            <th>Prior Year Revenue ITD</th>
            <th>Current Year Revenue YTD</th>
            <th>Current Year Revenue ITD</th>
            <th>Prior Year Fee ITD</th>
            <th>Current Year Fee YTD</th>
            <th>Current Year Fee ITD</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">

          <tr>
            <td> Revenue & Fee</td>
            <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input style="width:100%!important;" name="priorYearRevenueITD" type="number" [(ngModel)]="selectedRevenue.priorYearRevenueITD" pInputText />
            </span>
            </td>
            <td>
            <span class="p-inputgroup">
              <span class="p-inputgroup-addon">$</span>
              <input style="width:100%!important;" name="currentYearRevenueYTD" type="number" [(ngModel)]="selectedRevenue.currentYearRevenueYTD" pInputText />
            </span>
            </td>
            <td>
              {{ selectedRevenue.priorYearRevenueITD + selectedRevenue.currentYearRevenueYTD | currency: Format.Currency }}
            </td>
            <td>
              <span class="p-inputgroup">
                <span class="p-inputgroup-addon">$</span>
                <input style="width:100%!important;" name="priorYearFeeITD" type="number" [(ngModel)]="selectedRevenue.priorYearFeeITD" pInputText />
              </span>
            </td>
            <td>
              <span class="p-inputgroup">
                <span class="p-inputgroup-addon">$</span>
                <input style="width:100%!important;" name="currentYearFeeYTD" type="number" [(ngModel)]="selectedRevenue.currentYearFeeYTD" pInputText />
              </span>
            </td>
            <td>
              {{ selectedRevenue.priorYearFeeITD + selectedRevenue.currentYearFeeYTD | currency: Format.Currency }}
            </td>

          </tr>
        </ng-template>
      </p-table>

    </div>
  </form>
  <p-footer>
    <div class="details" style="text-align:right;margin:10px 10px 0 0;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" (click)="cancelRevenueDialog()" label="Cancel">
      </button>
      <span *ngIf="!goLiveAccountingPeriodClosed || inSolutionManager">
        <span *ngIf="!selectedRevenue?.id">
          <button [disabled]="!dialogForm.form.valid" pButton icon="fa fa-check" type="button" class="button-action" (click)="saveRevenue()" label="Save">
          </button>
        </span>
        <span *ngIf="selectedRevenue?.id">
          <button pButton icon="fa fa-check" type="button" class="button-action" (click)="updateRevenue()" label="Update">
          </button>
        </span>
      </span>

    </div>
  </p-footer>
</p-dialog>




<p-dialog *ngIf="displayRevenueBalanceDialog && RevenueBalanceType.ProjectClin == revenueBalanceType" (onHide)="hideDialog($event)" [(visible)]="displayRevenueBalanceDialog"
          header="Initial Revenue" styleClass="revenue-dialog" [responsive]="true" [closable]="false">

  <div class="p-col-12 p-md-12 p-lg-12">
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label *ngIf="projectId"> Project Name</label>
        <label *ngIf="clinId"> Clin Name</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        {{clinOrProjectName}}
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-6">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label> Accounting Period*</label>
      </div>
      {{orgAccountingCalendarBeforeGoLive?.title}} - {{orgAccountingCalendarBeforeGoLive?.start | date: Format.Date}} - {{orgAccountingCalendarBeforeGoLive?.end | date: Format.Date}}
    </div>

  </div>

  <div class="p-col-12">
    <p-table [value]="selectedRevenueList" [columns]="revenueBalanceColumns">
      <ng-template pTemplate="caption">
        <div class="p-col-12" style="text-align:right;">
          <button  pButton class="action-secondary" icon="fa fa-plus" type="button" (click)="addItem()" pTooltip="Add Entry" label="Add Entry"
                   tooltipPosition="top">
          </button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngSwitch]="col.field">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex" let-columns="columns">

        <tr>
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
              <span class="p-cell">
                <div *ngSwitchCase="'clinId'">
                  <span *ngIf="!row.id">
                  <p-dropdown filter="true" name="contractClin" [options]="clinsDropDown" placeholder="Select..." [(ngModel)]="row.clinId"></p-dropdown>
                  </span>
                  <span *ngIf="row.id">
                    {{row.optionNumber}} - {{row.clinName}}
                  </span>
                </div>
                <div *ngSwitchCase="'priorYearRevenueITD'">
                      <span class="p-inputgroup">
                        <span class="p-inputgroup-addon">$</span>
                        <input style="width:100%!important;" name="priorYearRevenueITDCol" type="number" [(ngModel)]="row.priorYearRevenueITD" pInputText />
                      </span>
                </div>
                <div *ngSwitchCase="'currentYearRevenueYTD'">
                    <span class="p-inputgroup">
                      <span class="p-inputgroup-addon">$</span>
                      <input style="width:100%!important;" name="currentYearRevenueYTDCol" type="number" [(ngModel)]="row.currentYearRevenueYTD" pInputText />
                    </span>
                </div>
                <div *ngSwitchCase="'currentYearRevenueITD'">
                    {{ row.priorYearRevenueITD + row.currentYearRevenueYTD | currency: Format.Currency }}
                </div>
                <div *ngSwitchCase="'priorYearFeeITD'">
                  <span class="p-inputgroup">
                    <span class="p-inputgroup-addon">$</span>
                    <input style="width:100%!important;" name="priorYearFeeITDCol" type="number" [(ngModel)]="row.priorYearFeeITD" pInputText />
                  </span>
                </div>
                <div *ngSwitchCase="'currentYearFeeYTD'">
                  <span class="p-inputgroup">
                    <span class="p-inputgroup-addon">$</span>
                    <input style="width:100%!important;" name="currentYearFeeYTDCol" type="number" [(ngModel)]="row.currentYearFeeYTD" pInputText />
                  </span>
                </div>
                <div *ngSwitchCase="'currentYearFeeITD'">
                  {{ row.priorYearFeeITD + row.currentYearFeeYTD | currency: Format.Currency }}
                </div>

                <div *ngSwitchCase="'action'">
                </div>
                <div *ngSwitchDefault>{{row[col.field]}}</div>
              </span>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>
  <p-footer>
    <div class="details" style="text-align:right;margin:10px 10px 0 0;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" (click)="cancelRevenueDialog()" label="Cancel">
      </button>
      <span *ngIf="!goLiveAccountingPeriodClosed || inSolutionManager">
            <button  pButton icon="fa fa-check" type="button" class="button-action" (click)="saveOrUpdateRevenueList()" label="Save">
            </button>
        </span>

    </div>
  </p-footer>
</p-dialog>
